import Layout from '@/pages/layout';
import HeaderImage from '@/pages/login/headerImage';

let routes = [
    {
        path: '/',
        redirect: '/group'
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/pages/login/index.vue')
    },
    {
        path: '/',
        component: Layout,
        children: [
            {
                path: '/header',
                name: 'header',
                meta: {
                    bread: [
                        {
                            title: '修改头像'
                        }
                    ]
                },
                component: HeaderImage
            },
            {
                path: '/dashboard',
                name: 'dashboard',
                meta: {
                    bread: [
                        {
                            title: ''
                        }
                    ]
                },
                component: () => import('@/pages/dashboard/index.vue')
            },
           
            {
                path: '/group',
                name: 'cardGroup',
                meta: {
                    bread: [
                        {
                            title: '打卡小组'
                        }
                    ]
                },
                component: () => import('@/pages/group/cardGroup/index.vue')
            },
            {
                path: '/applyRecord',
                name: 'applyRecord',
                meta: {
                    bread: [
                        {
                            title: '小组申请记录'
                        }
                    ]
                },
                component: () => import('@/pages/group/applyRecord/index.vue')
            },
            {
                path: '/tag',
                name: 'tag',
                meta: {
                    bread: [
                        {
                            title: '标签管理'
                        }
                    ]
                },
                component: () => import('@/pages/group/tag/index.vue')
            },
            {
                path: '/user',
                name: 'user',
                meta: {
                    bread: [
                        {
                            title: '用户管理'
                        }
                    ]
                },
                component: () => import('@/pages/user/index.vue')
            },
            {
                path: '/config',
                name: 'config',
                meta: {
                    bread: [
                        {
                            title: '配置中心'
                        }
                    ]
                },
                component: () => import('@/pages/config/config.vue')
            },
            {
                path: '/people/list',
                name: 'peopleList',
                meta: {
                    bread: [
                        {
                            title: '用户列表'
                        }
                    ]
                },
                component: () => import('@/pages/people/list.vue')
            },
            {
                path: '/people/comment',
                name: 'peopleComment',
                meta: {
                    bread: [
                        {
                            title: '评论管理'
                        }
                    ]
                },
                component: () => import('@/pages/people/comment.vue')
            },
            
            
        ]
    },
    {
        path: '/404',
        name: 'page404',
        component: () =>
            import(
                /* webpackChunkName: "dashboard-group" */ '@/pages/404/index.vue'
            )
    },
    
];
export default routes;



// 404页面路由
export const router404 = [{
    path: '*',
    redirect: '/404',
    name: 'notFound'
}];

export const asyncRouterMap = {
    path: '/',
    component: Layout,
    children: [
        // {
        //     path: '/situation',
        //     name: 'situation',
        //     redirect: '/dashboard',
        //     component: () =>
        //         import(
        //             /* webpackChunkName: "mailSecurity" */ '@/pages/mailSecurity/situation/situation.vue'
        //         ),
        //     meta: {
        //         bread: [
        //             {
        //                 title: '邮件安全态势'
        //             },
        //             {
        //                 title: '邮件态势感知'
        //             }
        //         ]
        //     }
        // },
        
    ]
};
